import { create } from "zustand";
import { Profile } from "../models/Profile";
import { Material } from "../models/Material";
import {
  createMaterial,
  deleteMaterial,
  getAllMaterials,
  updateMaterial,
} from "../repositories/MaterialsRepository";

export interface MaterialStore {
  fetchMaterials: (user: Profile) => Promise<Material[] | undefined>;
  addMaterial: (
    user: Profile,
    material: Material
  ) => Promise<number | undefined>;
  editMaterial: (
    user: Profile,
    material: Material,
    materialId: number
  ) => Promise<number | undefined>;
  removeMaterial: (
    user: Profile,
    materialId: number
  ) => Promise<number | undefined>;
}

export const useMaterial = create<MaterialStore>(() => ({
  fetchMaterials: (user) => {
    return getAllMaterials(user);
  },
  addMaterial: (user, material) => {
    return createMaterial(user, material);
  },
  editMaterial: (user, material, materialId) => {
    return updateMaterial(user, material, materialId);
  },
  removeMaterial: (user, materialId) => {
    return deleteMaterial(user, materialId);
  },
}));
